import { render, staticRenderFns } from "./buildAccountRecords.vue?vue&type=template&id=e7fd9790&scoped=true&"
import script from "./buildAccountRecords.vue?vue&type=script&lang=js&"
export * from "./buildAccountRecords.vue?vue&type=script&lang=js&"
import style0 from "./buildAccountRecords.vue?vue&type=style&index=0&id=e7fd9790&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fd9790",
  null
  
)

component.options.__file = "buildAccountRecords.vue"
export default component.exports